import React, { useState } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useTranslation } from 'react-i18next';
import { Icon, ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import MovementCard from './MovementCard';
import PropTypes from 'prop-types';
import moment from 'moment';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { isNullUndefined } from '../../../../../../common/Helpers';

const ELEMENT_LAST_MOVEMENTS = (props) => {
	
const { 
	inputParam_HideHeader = false,
	inputParam_ComponentContent = null,
    inputParam_UseFake = false,
	inputParam_BoardStructure = null,
    inputParam_Container = null
} = props;

const { t } = useTranslation();

const [movements, setMovements] = useState(inputParam_UseFake === false ? (!isNullUndefined(inputParam_ComponentContent) ? inputParam_ComponentContent.items : []) : [
	{
		type: 'EP',
		text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed elit nunc, mollis in rutrum nec, porttitor vitae neque.',
		color: '#84B681'
	},{
		type: 'EP',
		text: 'Sed nec est dui. Maecenas luctus tortor a porta mattis. Nullam maximus maximus diam, nec aliquet sem tincidunt varius.',
		color: '#D15555'
	},{
		type: 'EP',
		text: 'Morbi sed sem convallis, aliquet ipsum a, dictum velit.',
		color: '#D39128'
	},{
		type: 'EP',
		text: 'Quisque a rhoncus ex, vitae tincidunt purus. Aliquam hendrerit cursus est ac porta. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
		color: '#84B681'
	},{
		type: 'EP',
		text: 'Donec vel nunc arcu. Aliquam eget neque nisl. Pellentesque pellentesque eleifend faucibus. Phasellus a tempus ligula, et tempus erat.',
		color: '#D39128'
	}
]);

const renderContent = () => {
	return  <Row className='py-0 px-2 h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
				<ScrollablePane
					className='h-100'
					styles={{
						root: { height: `${50*6.5}px`, position: "relative" },
						contentContainer:{overflowX: "hidden"}
					}}
					scrollbarVisibility={ScrollbarVisibility.auto}
					scrollContainerFocus={true}
				>
					{
						movements && movements.sort((a, b) => moment(b.eventDate) - moment(a.eventDate)).map((movement, index) => (
							<div key={index} className='pt-1 m-1'>
								<MovementCard inputParam_ElementItem={movement}/>
							</div>
						))
					}
				</ScrollablePane>
			</Row>
}

return (
	<>
		{
			!inputParam_UseFake &&
			<Card className='board-element-form h-100 overflow-hidden'>
				{
					!inputParam_HideHeader &&
					<Card.Header className="card-header-compact">
						<Card.Title className="d-flex justify-content-between">
							<b>{ inputParam_ComponentContent !== null ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-movements')) : t('data-lang-boxname-movements')}</b>
							<div className='toolbar d-flex'>
								<HEADER_TOOLBAR
									inputParam_BoardStructure={inputParam_BoardStructure}
									inputParam_Container={inputParam_Container}
								/>
							</div>
						</Card.Title>
					</Card.Header>
				}
				<Card.Body className='px-2 py-0 h-100'>
					{renderContent()}
				</Card.Body>
			</Card>
		}
		{
			inputParam_UseFake && renderContent()
		}
	</>
)};

ELEMENT_LAST_MOVEMENTS.propTypes = {
};

export default ELEMENT_LAST_MOVEMENTS;